export const locations = {
  seo: {
    title: 'Our Locations | LensBank Professional Equipment Rental',
    description: '8 service locations across Taipei, Taichung, and Tainan for convenient equipment rental. Find store addresses, business hours, contact details, and directions.',
    keywords: 'locations,equipment rental locations,Taipei store,Taichung store,Tainan store,warehouse'
  },
  hero: {
    title: 'Our Locations',
    subtitle: '{{count}} service locations for convenient equipment rental'
  },
  types: {
    all: 'All',
    store: 'Store',
    warehouse: 'Warehouse'
  },
  card: {
    store: 'Store',
    warehouse: 'Warehouse',
    hours: 'Business Hours',
    phone: 'Phone',
    address: 'Address',
    viewDetails: 'View Details',
    getDirections: 'Get Directions'
  },
  detail: {
    overview: 'Location Overview',
    hours: 'Business Hours',
    contact: 'Contact',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    transportation: 'Getting Here',
    services: 'Services Available',
    equipmentRental: 'Equipment Rental',
    consultation: 'Expert Consultation',
    technicalSupport: 'Technical Support',
    pickup: 'Equipment Pickup',
    return: 'Equipment Return',
    map: 'Map',
    nearbyStores: 'Nearby Locations'
  },
  hours: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    closed: 'Closed'
  }
};
